import Modal from './modal.js';
import { initLazyMedia } from '../utils/helpers/lazy-media.js';

const SELECTORS = {
    CONTENT: '[data-content]',
    LOADING: '[data-loading]',
    OPEN_PAGE_ATTRIBUTE: 'open-page-modal'
};

class ViewPageModal extends Modal {
    constructor() {
        super();
    }

    connectedCallback() {
        super.connectedCallback();
        this.contentElement = this.querySelector(SELECTORS.CONTENT);
        this.loadingElement = this.querySelector(SELECTORS.LOADING);

        if (!this.contentElement) {
            return console.error('[view-page-modal] Content element not found for', this);
        }
        this.initEventListeners();
    }

    initEventListeners() {
        this.delegateClickDocument(`[${SELECTORS.OPEN_PAGE_ATTRIBUTE}]`, this.handleOpenPageModal.bind(this));
    }

    handleOpenPageModal(el) {
        console.log('handleOpenPageModal', el);
        const url = el.getAttribute(SELECTORS.OPEN_PAGE_ATTRIBUTE);
        if (!url) {
            return console.error('[view-page-modal] No URL found for', el);
        }

        this.open();

        this.loadPage(url);
    }

    async loadPage(pageUrl) {
        try {
            this.setLoadingState(true);
            const fullUrl = `${window.location.origin}${pageUrl}`;
            const response = await fetch(fullUrl);
            const html = await response.text();

            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const mainContent = doc.querySelector('main');

            if (mainContent && this.contentElement) {
                this.contentElement.innerHTML = mainContent.innerHTML;
            }

            this.setLoadingState(false);

            initLazyMedia();
        } catch (error) {
            console.error('Error loading page:', error);

            if (this.contentElement) {
                this.contentElement.innerHTML =
                    '<div class="text-center py-12 text-gray-500">Error loading page</div>';
            }
            this.setLoadingState(false);
        }
    }

    setLoadingState(isLoading) {
        if (this.loadingElement) {
            this.loadingElement.classList.toggle('js-hidden', !isLoading);
        }

        if (this.contentElement) {
            this.contentElement.classList.toggle('js-hidden', isLoading);
        }
    }

    getScrollLockTarget() {
        return null;
    }
}

customElements.define('view-page-modal', ViewPageModal);
